import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import {ImgPro} from '../../ui/components/navbar/NavbarStyles.elements';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import {Contenido, EncabezadoModal, ModalContent, Modales, BtnCloseCarrito} from '../../ui';
import {FormattedNumber} from "../../common/ui/FormattedNumber";
import {ModalTableContainer, ModalTableWrapper, ModalTable, ModalTableBody} from '../../ui/styles/Carrito.elements';

// DEPRECATED - TODO move to order domain
export const ProductsModal = ({ title, products, onModalClose }) => {
  return (
    <>
      <Modales>
        <ModalContent>
          <EncabezadoModal>
            <span className="text-primary">{title}</span>
            <BtnCloseCarrito onClick={() => onModalClose()}>
              <CloseIcon />
            </BtnCloseCarrito>
          </EncabezadoModal>
          <Contenido>
            <ModalTableContainer>
              <ModalTableWrapper>
                <ModalTable>
                  <thead>
                    <tr>
                      <th className="col-img">Imagen</th>
                      <th className="col-producto">Producto</th>
                      <th className="col-codigo">Código</th>
                      <th className="col-unidades">Unidades</th>
                      <th className="col-precio">Precio compra</th>
                    </tr>
                  </thead>
                  <ModalTableBody>
                    {
                      products.map((product, index) => (
                        <tr key={index}>
                          <td className="col-img">
                            {
                              !!product.packParentId ? (
                                <CardGiftcardIcon className="text-primary" fontSize="large" />
                              ) : (
                                <ImgPro src={product.image} alt="ImgProduct" />
                              )
                            }
                          </td>
                          <td className="col-producto">{product.name}</td>
                          <td className="col-codigo">{product.code}</td>
                          <td className="col-unidades">{product.quantity}</td>
                          <td className="col-precio"><FormattedNumber value={product.sellingPrice} config={{style: "currency"}}/></td>
                        </tr>
                      ))
                    }
                  </ModalTableBody>
                </ModalTable>
              </ModalTableWrapper>
            </ModalTableContainer>
          </Contenido>
        </ModalContent>
      </Modales>
    </>
  );
};

